import React, { ElementType, MouseEventHandler, ReactNode } from 'react'
import {
  BackdropTypeMap,
  ModalComponentsPropsOverrides,
  ModalOwnerState,
  Dialog as MUIDialog,
  PaperProps,
  SlotComponentProps
} from '@mui/material'
import { TransitionProps } from '@mui/material/transitions'
import { OverridableComponent } from '@mui/material/OverridableComponent'

export interface DialogProps {
  children: ReactNode
  component?: ElementType<any>
  disablePortal?: boolean
  fullWidth?: boolean
  hideBackdrop?: boolean
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false
  onClose?: () => void
  onMouseDown?: MouseEventHandler<HTMLElement>
  open: boolean
  PaperProps?: PaperProps
  slotProps?: {
    backdrop?: SlotComponentProps<
      OverridableComponent<BackdropTypeMap<object, 'div'>>,
      ModalComponentsPropsOverrides,
      ModalOwnerState
    >
  }
  sx?: object
  TransitionComponent?:
    | React.JSXElementConstructor<
        TransitionProps & {
          children: React.ReactElement<any, any>
        }
      >
    | undefined
}

/**
 * The Dialog component inform users about
 * a task and can contain critical information,
 * require decisions, or involve multiple tasks.
 */

const Dialog = React.forwardRef((props: DialogProps, ref: any) => {
  const { children, onClose, PaperProps, slotProps, ...rest } = props

  return (
    <MUIDialog
      {...rest}
      onClose={(event: any) => {
        event?.stopPropagation()

        onClose?.()
      }}
      ref={ref}
      slotProps={{
        backdrop: {
          onClick: (event: any) => event?.stopPropagation(),
          onMouseDown: (event: any) => event?.stopPropagation(),
          ...slotProps?.backdrop,
          sx: {
            backdropFilter: 'grayscale(100%)',
            ...(slotProps?.backdrop as { sx?: object })?.sx
          }
        }
      }}
      PaperProps={{
        onClick: (event: any) => event?.stopPropagation(),
        onMouseDown: (event: any) => event?.stopPropagation(),
        ...PaperProps
      }}
    >
      {children}
    </MUIDialog>
  )
})

Dialog.displayName = 'Dialog'
export default Dialog
